import styled from 'styled-components';

import DroppableTileList from './DroppableTileList.jsx';
import { TabWithPlaceholder } from './TabWithPlaceholder.jsx';
import { TilesWrapper } from '../StyledComponents';

const DroppableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const GenericTabContainer = ({
  activeFilters,
  activeStatus,
  changeTileStatus,
  handleMenuAction,
  hasEmptyTileFillers = false,
  isUserSiteAdmin,
  moveTileToProof,
  tiles,
  dndContext,
  pageNumber,
  pageSize,
}) => {
  return (
    <TabWithPlaceholder tiles={tiles} showStats={true}>
      <TilesWrapper>
        <DroppableContainer>
          <DroppableTileList
            activeFilters={activeFilters}
            activeStatus={activeStatus}
            changeTileStatus={changeTileStatus}
            handleMenuAction={handleMenuAction}
            hasEmptyTileFillers={hasEmptyTileFillers}
            isUserSiteAdmin={isUserSiteAdmin}
            moveTileToProof={moveTileToProof}
            tiles={tiles}
            bucketDate="generic"
            dndContext={dndContext}
            pageNumber={pageNumber}
            pageSize={pageSize}
            showStats={true}
          />
        </DroppableContainer>
      </TilesWrapper>
    </TabWithPlaceholder>
  );
};
